import { render } from "./CoursesComponent.vue?vue&type=template&id=3299dcf8"
import script from "./CoursesComponent.vue?vue&type=script&lang=js"
export * from "./CoursesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__